import ArticlePage from "@pages/Article/Article.tsx";
import HomePage from "@pages/Home/Home.tsx";
import PhotoGalleryPage from "@pages/PhotoGallery/PhotoGallery.tsx";
import RecentArticlesPage from "@pages/RecentArticles/RecentArticles.tsx";
import SectionPage from "@pages/Section/Section.tsx";
import { AuthCallback } from "@sphtech/web2-core/auth";
import { fetchContext } from "@sphtech/web2-core/ssr";
import { RouteObject } from "react-router-dom";

import {
  getClientId,
  getIssuer,
} from "../../.web2/web2-helpers/auth/MySphConfig";
import App from "./App";
import Newsletter from "./pages/Newsletter/Newsletter";
import PodcastPage from "./pages/Podcast/Podcast";
import VideoPage from "./pages/Video/Video";

export const reactRouterRoutes: RouteObject[] = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <HomePage />,
        loader: fetchContext,
      },
      /**
       * Integration guide: https://sph.atlassian.net/wiki/x/V4GqY
       */

      {
        path: "/oauth/callback",
        element: <AuthCallback clientId={getClientId()} issuer={getIssuer()} />,
      },
      {
        path: "/article/:id",
        element: <ArticlePage />,
        loader: fetchContext,
      },
      {
        path: "/apple-app-site-association",
        element: <></>,
        loader: fetchContext,
      },
      {
        path: "/.well-known/assetlinks.json",
        element: <></>,
        loader: fetchContext,
      },
      {
        path: "/:section/:slug",
        element: <ArticlePage />,
        loader: fetchContext,
      },
      {
        path: "/videos",
        element: <VideoPage />,
        loader: fetchContext,
      },
      // {
      //   path: "/:section/:second/:slug",
      //   element: <ArticlePage />,
      //   loader: fetchContext,
      // },
      {
        path: "/podcasts",
        element: <PodcastPage />,
      },
      {
        path: "/podcasts/:level1",
        element: <PodcastPage />,
      },
      {
        path: "/recent-articles",
        element: <RecentArticlesPage />,
        loader: fetchContext,
      },
      {
        path: "/photo-gallery",
        element: <PhotoGalleryPage />,
        loader: fetchContext,
      },
      {
        path: "/:level1",
        element: <SectionPage />,
        loader: fetchContext,
      },
      // {
      //   path: "/:level1/:level2",
      //   element: <SectionPage />,
      //   loader: fetchContext,
      // },
      {
        path: "/newsletter/sign-up",
        element: <Newsletter />,
      },
      {
        path: "*",
        element: (
          <>
            <h1>404</h1>
            <br />
            <h2>The page you are looking for is not found!</h2>
          </>
        ),
      },
    ],
  },
];

export const routes = reactRouterRoutes.reduce(
  (_routes: string[], currentRoute: RouteObject) => {
    if (currentRoute.path) {
      _routes = [..._routes, currentRoute.path];
    }

    if (currentRoute.children) {
      for (const child of currentRoute.children) {
        if (child.path) {
          _routes = [..._routes, child.path];
        }
      }
    }

    return _routes;
  },
  [],
);
